////////////////
// Analytics //
//////////////

import GameAnalytics from "not-game-analytics"

GameAnalytics.GAME_KEY = "172ea4c9591d1b3f7b47ecc1358785ee"
GameAnalytics.SECRET_KEY = "87b7619ed81226fbfcc3b489d21829e8a11ab325"
GameAnalytics.BUILD_VERSION = __VERSION__
GameAnalytics.isReporting = true // __STAGE__ != "DEVELOPMENT"
// GameAnalytics.isLogging = true
window.addEventListener("error", (error) => {
    GameAnalytics.reportError(error)
})

GameAnalytics.reportStageStart("Stage1")

// TODO: GameAnalytics is TOO BIG.
